export default "<div #subscriberDiv></div>\r\n"